// extracted by mini-css-extract-plugin
export default {"map":"Buttons_map__oODhh","emph":"Buttons_emph__CQmNi","wrapper":"Buttons_wrapper__Y9A71","text":"Buttons_text__C+81e"};